import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  padding: 40px 35%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;
